export type Product = {
  id: string;
  name: string;
  slug: string;
  species: string;
  prepType: string;
  shortDescription: string | null;
  isHalalCertified: boolean;
  pricingType: string;
  unit: string;
  price: number | null;
  currency: string;
};

export function ProductCard({ products }: { products: Product[] }) {
  return (
    <div className="space-y-2 my-3">
      {products.map((product) => (
        <div
          key={product.id}
          className="bg-[var(--color-muted)] rounded-xl p-3 border border-[var(--color-border)]"
        >
          <div className="flex items-start justify-between gap-2">
            <div className="flex-1">
              <div className="font-medium text-sm">{product.name}</div>
              {product.shortDescription && (
                <div className="text-xs text-gray-500 mt-0.5">{product.shortDescription}</div>
              )}
              <div className="flex items-center gap-2 mt-2">
                <span className="text-xs capitalize bg-white px-2 py-0.5 rounded-full border border-[var(--color-border)]">
                  {product.species}
                </span>
                <span className="text-xs capitalize bg-white px-2 py-0.5 rounded-full border border-[var(--color-border)]">
                  {product.prepType.replace(/_/g, " ")}
                </span>
                {product.isHalalCertified && (
                  <span className="text-xs bg-[var(--color-accent)]/10 text-[var(--color-accent)] px-2 py-0.5 rounded-full border border-[var(--color-accent)]/30">
                    Halal ✓
                  </span>
                )}
              </div>
            </div>
            <div className="text-right flex-shrink-0">
              {product.price !== null && (
                <div className="font-heading font-bold text-[var(--color-accent)]">
                  £{product.price.toFixed(2)}
                  <span className="text-xs text-gray-400 font-normal">/{product.unit}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
